var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getComponentVisibility()),expression:"getComponentVisibility()"}],attrs:{"id":_vm.$root.$config.element,"app":"ge-component"}},[_c(_vm.$root.$config.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }